import { coreWalletMappers } from 'cw-core-admin-ui/src/dataProvider/coreWalletDataProvider';
import PurchaseMapper from '../resources/purchases/PurchaseMapper';
import ShopConfigurationMapper from '../resources/shopConfigurations/ShopConfigurationMapper';
import LoyaltyProgramMapper from '../resources/loyaltyPrograms/LoyaltyProgramMapper';
import LoyaltyProgramMembershipMapper from '../resources/loyaltyProgramMemberships/LoyaltyProgramMembershipMapper';
import LoyaltyCreditMapper from '../resources/loyaltyCredits/LoyaltyCreditMapper';
import MarketplacePurchaseMapper from '../resources/marketplaces/purchases/MarketplacePurchaseMapper';
import MarketplaceSellerMapper from '../resources/marketplaces/sellers/MarketplaceSellerMapper';
import MarketplaceMapper from '../resources/marketplaces/MarketplaceMapper';
import MarketplaceAuthenticationMapper from '../resources/marketplaces/authentications/MarketplaceAuthenticationMapper';
import InvoiceVoucherMapper from '../resources/invoiceVoucher/InvoiceVoucherMapper';

const demoWalletMappers = {
	purchases: new PurchaseMapper(),
	shopConfigurations: new ShopConfigurationMapper(),
	invoiceVouchers: new InvoiceVoucherMapper(),
	loyaltyPrograms: new LoyaltyProgramMapper(),
	loyaltyProgramMemberships: new LoyaltyProgramMembershipMapper(),
	loyaltyCredits: new LoyaltyCreditMapper(),
	marketplacePurchases: new MarketplacePurchaseMapper(),
	marketplaceSellers: new MarketplaceSellerMapper(),
	marketplaces: new MarketplaceMapper(),
	marketplaceAuthentications: new MarketplaceAuthenticationMapper(),
};

const demoWalletDataProvider = (type, resource, params) => {
	const mapper = demoWalletMappers[resource] || coreWalletMappers[resource] || coreWalletMappers['_default_'];
	return mapper.run({ type, resource, params });
};

export default demoWalletDataProvider;
